module.exports = __webpack_public_path__ + "static/media/singapore-fleg.530400db.svg";